<template>
  <div class="client_request_approve">
    <div class="header">
      <h4 class="title">
        {{ translate("client_request.approve")}}
        {{ device_fid }}
        {{ device_name ? '(' + device_name + ')' : "" }}
      </h4>
    </div>
    <div class="content">
      <div class="top">
        Устройство будет работать на

        <div class="form_select w50">
          <tree-select
              :options="simcard_count_list"
              :multiple="false"
              v-model="count_after_block"
              :placeholder="translate('client.state')"
              :clearable="false"
          />
        </div>

        {{ count_after_block === 1 ? "сим-карте" : "сим-картах"}}.
      </div>

      <p class="text-center" v-if="count_after_block !== simcard_mno.length">
        Необходимо выбрать {{ simcard_mno.length - count_after_block }} {{ simcard_mno.length - count_after_block ===  1 ? "сим-карту" : "сим-карты"}} для <b>блокировки</b>
      </p>

      <div class="line" v-if="count_after_block !== simcard_mno.length && count_after_block > 0">
        <div
          class="filter checkbox red-checkbox slider-switch"
          v-for="(simcard, key) in simcard_list"
          :key="key"
        >
          <div class="info">
            {{ simcard.label }}
          </div>
          <label class="switch" @click.prevent="simcard.value = !simcard.value">
            <input type="checkbox" v-model="simcard.value" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <div class="line" v-if="$store.getters.getPermissions.permissionGod === true && count_after_block !== simcard_mno.length && count_after_block > 0">
        <div class="filter checkbox slider-switch filter_power" >
          <div class="info">
            Отключить питание на указанных модулях
          </div>
          <label class="switch" @click.prevent="data.power_off_unused_modules = !data.power_off_unused_modules">
            <input type="checkbox" v-model="data.power_off_unused_modules" />
            <span class="slider round"></span>
          </label>

        </div>
      </div>

      <div class="line text_wrap">
        <div class="form-group">
          <label> {{ translate('client_request.comment') }} </label>
          <textarea class="input_text" name="comment" v-model="data.comment" rows="3" />
        </div>
      </div>

    </div>

    <div class="footer">
      <span
          :disabled="disable_approve"
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="approve"
      >
        {{ translate('btn.edit') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </span>
    </div>
  </div>

</template>
<script>

import GlobalConfirm from "../../../../../../../../../components/UIComponents/Confirm/GlobalConfirm.vue";

export default {
  name: "ClientRequestDeviceApprove",
  props: [
    "device_fid",
    "device_id",
    "device_name",
    "simcard_count_to_block",
    "simcard_mno"
  ],
  data () {
    return {
      simcard_list: [],
      data: {
        comment: "",
        power_off_unused_modules: false
      },
      count_after_block: null
    }
  },
  computed:{
    simcard_count_list(){
      return Array.from({ length: this.simcard_mno.length }, (_, index) => ({
        id: index + 1,
        label: index + 1,
      }));
    },
    disable_approve(){
      return this.simcards_to_block.length !== this.simcard_mno.length - this.count_after_block
    },
    simcards_to_block(){
      return this.simcard_list.map((simcard) => {
        if (simcard.value) return simcard.label
      }).filter((element) => { return element !== undefined })
    }
  },

  mounted() {
    this.simcard_list = this.simcard_mno.map((item) => {
      return {label: item, value: false}
    })
    this.count_after_block = this.simcard_mno.length - this.simcard_count_to_block
  },

  watch:{
    count_after_block(){
      this.simcard_list.forEach(simcard =>{
        simcard.value = false
      })
    }
  },

  methods: {
    cancel () {
      this.$emit('close')
    },

    confirm_approve(data){
      this.$http.v1.approveDeviceClientRequestList(data, () => {
        this.global_notify("info", this.translate("profile_saved"));
        this.$emit("update")
      })
    },

    approve(){
      if (this.disable_approve) return
      let data = {...this.data}
      data.device_id = this.device_id
      data.simcards_to_block = this.simcard_list.map((simcard) => {
        if (simcard.value) return simcard.label
      }).filter((element) => { return element !== undefined })

      if (data.simcards_to_block.length > 0){
        let string = "Вы уверены, что хотите подать заявку на блокировку сим-карт:"
        for (const key in data.simcards_to_block) {
          string += ` ${data.simcards_to_block[key]}`
          if (key !== data.simcards_to_block.length-1){
            string += ","
          }
        }

        let t = this.$createElement(GlobalConfirm, {
          props: {
            text: string
          },
          on: {
            close: () => {
              this.$modal.hide('confirm_blocked_sim')
            },
            confirm: () => {
              this.confirm_approve(data)
              this.$modal.hide('confirm_blocked_sim')
            }
          }
        })
        let temp = { render () { return t } }
        this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'confirm_blocked_sim'})
      } else {
        this.confirm_approve(data)
      }
    }
  }
}

</script>

<style lang='scss' scoped>
  .client_request_approve{
    padding: 10px;
    .header{
      padding: 10px 0;
      .title{
        font-size: 22px;
        font-weight: 600;
        margin: 0;
        text-align: center;
      }
    }
    .content{
      padding: 10px 0;
      .top{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        .w50{
          width: 50px
        }
      }
      .text-center{
        font-size: 14px;
        b{
          color: #EB5E28;
          text-transform: uppercase;
        }
      }

      .line{
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }

        .checkbox{
          min-width: auto;
          width: 100%;
          margin: 0;
        }
        .filter{
          &.filter_power{
            flex-direction: row-reverse;
            gap: 10px;
          }
        }
      }
    }
    .footer{
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        margin: 0 5px;
        display: block;
      }
    }
  }

</style>
